import { LazyQueryResultTuple, useLazyQuery } from '@apollo/client'
import { APPRAISALS_OF_EMPLOYEE_BY_YEAR } from '../Queries'
import { AppraisalsOfEmployeeByYearQuery, AppraisalsOfEmployeeByYearQueryVariables } from '../../../types'

export const useAppraisalsOfEmployeeByYear = (): LazyQueryResultTuple<
  AppraisalsOfEmployeeByYearQuery,
  AppraisalsOfEmployeeByYearQueryVariables
> => {
  return useLazyQuery<AppraisalsOfEmployeeByYearQuery, AppraisalsOfEmployeeByYearQueryVariables>(APPRAISALS_OF_EMPLOYEE_BY_YEAR, {
    fetchPolicy: 'network-only',
  })
}
